<template>
  <Dropdown
    v-model="selectedPodcaster"
    :options="podcasterList"
    option-label="email"
    option-value="podcaster_id"
    placeholder="All Podcasters"
    class="tw-border-none tw-outline-none tw-shadow-none tw-bg-none tw-bg-transparent tw-items-center tw-max-w-full sm:tw-max-w-72"
    input-class="tw-text-3xl md:tw-text-[40px] tw-font-light tw-p-0 tw-leading-normal"
    panel-class="tw-max-w-xs md:tw-max-w-sm lg:tw-max-w-lg xl:tw-max-w-2xl"
    filter
    @change="(e) => emits('selectPodcaster', e.value)"
  />
</template>

<script setup>
import Dropdown from "primevue/dropdown";
import { computed, ref, onMounted } from "vue";
import { useStore } from "vuex";

const emits = defineEmits(["selectPodcaster"]);
const store = useStore();

const token = localStorage.getItem("networkAdminToken");
const selectedPodcaster = ref("all");

const podcasterList = computed(() => {
  let tempPodcasters = store.getters.podcasters;
  if (!tempPodcasters) {
    tempPodcasters = [];
  }
  tempPodcasters = tempPodcasters.map((item) => ({ ...item }));
  tempPodcasters.unshift({
    email: "All Podcasters",
    podcaster_id: "all",
  });
  return tempPodcasters;
});

onMounted(() => {
  if (!store.getters.podcasters || store.getters.podcasters.length === 0) {
    store.dispatch("loadPodcasters", { token });
  }
});
</script>
